<template>
  <div class="content-wrapper">
    <div class="row">
      <!-- <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('responses')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div> -->

      <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div
          class="p-primary align-items-center primary-card-color border-bottom"
        >
          <ul
            class="nav tab-filter-menu d-inline-flex justify-content-flex-end"
          >
            <li
              class="nav-item"
              v-for="(item, index) in userFilterOptions"
              :key="index"
            >
              <a
                href="#"
                class="nav-link font-size-default py-0"
                :class="[
                  filteredData.status == item.id
                    ? 'active'
                    : index === 0 && filteredData.status === ''
                    ? 'active'
                    : '',
                ]"
                @click.prevent="getFilterValue(item.id)"
              >
                {{ item.value }}
              </a>
            </li>
          </ul>
          <div class="float-right">
            <app-search @input="getSearchValue" />
          </div>
        </div>
      </div> -->
    </div>
    <div v-if="this.active != 1" class="mb-2">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-if="this.active < 3">
          <a href="" @click.prevent="previous">List</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="active === 2">Task Detail</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form v-if="active === 1"> 
      <div class="col-sm-12 col-md-12 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="certificateIssue"
          >
            {{ $t("certificate_issue") }}
          </button>
        </div>
      </div>
        <app-table
        :id="tableId"
        :options="options"

        :filtered-data="filteredData"
        @action="getListAction"
      />
    </el-form>
    <el-form v-if="active === 2">
      <div class="remove-title">
        <task-mytask-view
          :id="id"
          :remove="classRemove"
          :active="{ active }"
        ></task-mytask-view>
      </div>
    </el-form>

    <task-mytaskmodal
      v-if="isMYTASKModalActive"
      @close-modal="closeAddEditModal"
      :id="id"
    />

    <certificate-audit-request-modal
      v-if="isAddEditModalActive"
      :id="id"
      @close-modal="closerequestModal"
    />
    <!-- Certificate issue Modal -->
    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="certificate-issue-modal"
      :message="message"
      @confirmed="confirmed"
      @cancelled="canceled"
    />
  </div>
</template>

<script>
// import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../../Demo/Tables/mixins/TableHelpers";
import { axiosPost} from "../../../../../../Helpers/AxiosHelper";

export default {
  // extends: CoreLibrary,
  name: "tab-filter",
  mixins: [TableHelpers],
  data() {
    return {message: '',
      certificatedata: {},
      active: 1,
      classRemove: true,
      isMYTASKModalActive: false,
      id: 0,
      invoice: {},
      isAddEditModalActive: false,
      isEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      titleinvoice: "",
      results: "",
      tableId: "filter-without-wrapper",
      filteredData: {
        status: "",
      },
      search: "",
      rowData: {},
      options: {
        name: this.$t("tab_filter"),
        url: actions.CUSTOMER_INVOICE_LISTING,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("form"),
            type: "custom-html",
            key: "title",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "description",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "completed") ClassName = `success`;
              else if (value === "incomplete") ClassName = `warning`;
              else if (value === "action_required") {
                ClassName = `info`; value = 'Action Required';}

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },

        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
          {
            title: this.$t("send_request"),
            icon: "navigation",
            type: "none",
          },
        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      userFilterOptions: [
        { id: "", value: "All Invoices" },
        { id: "succeeded", value: "Paid" },
        { id: "pending", value: "Overdue" },
        // { id: "invited", value: "Invited" },
      ],
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    closeAddEditModal() {
      $("#my_task_modal").modal("hide");
      this.isMYTASKModalActive = false;
      // this.searchAndSelectFilterOptions();
    },
    previous() {
      this.active = 1;
    },
    getSearchValue(value) {
      let instance = this;
      this.search = value;
      setTimeout(function () {
        instance.$hub.$emit("reload-" + instance.tableId);
      });
    },
    getFilterValue(item) {
      this.filteredData.status = item;
      
      this.$hub.$emit("reload-" + this.tableId);
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isEditModalActive = false;
      this.getFilterValue();
      this.reSetData();
    },
    closerequestModal() {
      $("#certificate-form-audit-request").modal("hide");
      this.isAddEditModalActive = false;
      this.getFilterValue();
      this.reSetData();
    },
    getListAction(rowData, actionObj, active) {
      this.$store.commit('updateSharedData', {index: "taskId", newValue: rowData.id})

      this.rowData = rowData;

      if (actionObj.title == this.$t("view")) {
        this.id = rowData.id;
        this.active = 2;
      }
      else if (actionObj.title == this.$t("send_request")) {
        this.id = rowData.id;
        this.isAddEditModalActive = true;
      }
    },
    //Certificate issue Modal
    certificateIssue() {
      this.message = 'Are you sure you want to issue certificate?';
      this.certificatedata.certificate_id = this.$attrs['props'].certificate_id;
      this.certificatedata.company_id = this.$attrs['props'].company_id;
      this.certificatedata.user_id = this.$attrs['props'].user_id;
      this.certificatedata.type = this.$attrs['props'].type;
      this.deleteConfirmationModalActive = true;
      },
    confirmed() {
      axiosPost(actions.CERTIFICATE_ISSUE, this.certificatedata)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((res) => {
            
            this.$toastr.e(res.data.message);
          });

      this.hideDeleteModal();
    },
    hideDeleteModal() {
      this.deleteLoader = false;
      $("#certificate-issue-modal").modal("hide");
      this.canceled();
    },
    canceled() {
      this.message = '';
      this.deleteConfirmationModalActive = false;
    },
  },
  mounted() {
    let id = this.$attrs['props'].certificate_id;
    let company_id = this.$attrs['props'].company_id;
    this.options.url =
      actions.BUYER_CERTIFICATE_FORM_RESPONSES + "/" + id+'?company_id='+company_id;
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
